import { StyleSheet } from 'aphrodite';
import { CssSelectors, Layouts } from '../../../../web/styles/styles';
import { brandPrimary, brandPrimaryDark, brandSecondary, white } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		justifyContent: 'center',
		...Layouts.horizontalStack(30),
	},
	outcomeSelect: {
		backgroundColor: brandPrimary,
		border: `1px solid ${brandSecondary}`,
		color: white,
	},
	outcomeSelectDropdown: {
		backgroundColor: brandPrimary,
		border: `1px solid ${brandSecondary}`,
	},
	outcomeSelectItem: {
		color: white,
		':is([data-highlighted])': {
			backgroundColor: brandPrimaryDark,
		},
		':is([data-selected])': {
			backgroundColor: brandPrimaryDark,
		},
	},
	searchIcon: {
		marginRight: 6,
	},
	selectedUser: {
		marginRight: 10,
	},
	userAutocomplete: {
		...CssSelectors.allDescendants(
			{
				minWidth: '100%',
			},
			'.user-auto-complete-anchor'
		),
		...CssSelectors.allDescendants(
			{
				...CssSelectors.allDescendants(
					{
						background: brandPrimary,
						border: `1px solid ${brandSecondary}`,
						...CssSelectors.allDescendants(
							{
								borderRadius: 3,
							},
							'.item'
						),
						...CssSelectors.allDescendants(
							{
								color: white,
							},
							'.name'
						),
						...CssSelectors.allDescendants(
							{
								color: brandSecondary,
							},
							'.email'
						),
						...CssSelectors.allDescendants(
							{
								backgroundColor: brandPrimaryDark,
							},
							'.highlighted'
						),
					},
					'.dropdown-content'
				),
			},
			'.user-auto-complete-dropdown'
		),
		...CssSelectors.allDescendants(
			{
				background: brandPrimary,
				border: `1px solid ${brandSecondary}`,
				borderRadius: 3,
				minWidth: 300,
				...CssSelectors.allDescendants(
					{
						color: white,
					},
					'input'
				),
			},
			'.autocomplete-search-field-input'
		),
	},
});
